<template>
  <Layout>
    <div class="checkout-complete">
      <h1 class="main-title">購物車</h1>
      <h2 class="sub-title">SHOPPING CART</h2>
      
      <!-- 進度條 -->
      <div class="progress-bar">
        <div class="progress-step">
          <div class="step-number">1</div>
          <div class="step-label">購物車</div>
        </div>
        <div class="progress-line"></div>
        <div class="progress-step">
          <div class="step-number">2</div>
          <div class="step-label">結帳</div>
        </div>
        <div class="progress-line"></div>
        <div class="progress-step active">
          <div class="step-number">3</div>
          <div class="step-label">完成</div>
        </div>
      </div>

      <!-- 完成訂購內容 -->
      <div class="completion-content">
        <img :src="require('@/assets/img/checkout-done.png')" alt="訂購完成" class="completion-icon">
        <h2 class="completion-title">已成功送出</h2>
        <div class="completion-actions">
          <button @click="goToCart" class="action-btn cart-btn">返回購物車</button>
          <button @click="continueShopping" class="action-btn shop-btn">繼續購物</button>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layouts/Layout.vue'

export default {
  name: 'Done',
  components: {
    Layout
  },
  mounted() {
    this.clearCart()
  },
  methods: {
    clearCart() {
      this.$store.commit('clearCart')
    },
    goToCart() {
      this.$router.push('/checkout/cart')
    },
    continueShopping() {
      this.$router.push('/products')
    }
  }
}
</script>

<style scoped>
.checkout-complete {
  max-width: 1200px;
  margin: 80px auto 2rem auto;
  padding: 0 2rem;
}

.main-title {
  font-size: 2.5rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 0.5rem;
}

.sub-title {
  font-size: 1rem;
  color: #666;
  text-align: center;
  margin-bottom: 2rem;
}

.progress-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 3rem;
}

.progress-step {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.step-number {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #F99393;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.progress-step.active .step-number {
  background-color: #F99393;
  color: white;
}

.progress-line {
  position: relative;
  top: -15px;
  width: 100px;
  height: 2px;
  background-color: #F99393;
  margin: 0 1rem;
}

.completion-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 0;
  text-align: center;
}

.completion-icon {
  width: 120px;
  height: 120px;
  margin-bottom: 2rem;
}

.completion-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 2rem;
}

.completion-actions {
  display: flex;
  gap: 1rem;
}

.action-btn {
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.cart-btn {
  background-color: #F99393;
  color: white;
  border: none;
}

.cart-btn:hover {
  background-color: #F88282;
}

.shop-btn {
  background-color: white;
  color: #F99393;
  border: 1px solid #F99393;
}

.shop-btn:hover {
  background-color: #FFF5F5;
}
</style> 